import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const levelsManifest: FeatureManifest = {
  id: 'english-language-levels',
  path: 'english-knowledge/levels/*',
  navPath: '/english-knowledge/levels',
  label: 'Cấp độ',
  description: 'Tên và mô tả các cấp độ phát triển',
  navigationGroup: { id: 'english-skills', label: 'Tiêu chuẩn' },
  load: () => import('./entry'),
}
